export const timeRanges = [
  { id: "00:00:00", label: "00:00" },
  { id: "00:30:00", label: "00:30" },
  { id: "01:00:00", label: "01:00" },
  { id: "01:30:00", label: "01:30" },
  { id: "02:00:00", label: "02:00" },
  { id: "02:30:00", label: "02:30" },
  { id: "03:00:00", label: "03:00" },
  { id: "03:30:00", label: "03:30" },
  { id: "04:00:00", label: "04:00" },
  { id: "04:30:00", label: "04:30" },
  { id: "05:00:00", label: "05:00" },
  { id: "05:30:00", label: "05:30" },
  { id: "06:00:00", label: "06:00" },
  { id: "06:30:00", label: "06:30" },
  { id: "07:00:00", label: "07:00" },
  { id: "07:30:00", label: "07:30" },
  { id: "08:00:00", label: "08:00" },
  { id: "08:30:00", label: "08:30" },
  { id: "09:00:00", label: "09:00" },
  { id: "09:30:00", label: "09:30" },
  { id: "10:00:00", label: "10:00" },
  { id: "10:30:00", label: "10:30" },
  { id: "11:00:00", label: "11:00" },
  { id: "11:30:00", label: "11:30" },
  { id: "12:00:00", label: "12:00" },
  { id: "12:30:00", label: "12:30" },
  { id: "13:00:00", label: "13:00" },
  { id: "13:30:00", label: "13:30" },
  { id: "14:00:00", label: "14:00" },
  { id: "14:30:00", label: "14:30" },
  { id: "15:00:00", label: "15:00" },
  { id: "15:30:00", label: "15:30" },
  { id: "16:00:00", label: "16:00" },
  { id: "16:30:00", label: "16:30" },
  { id: "17:00:00", label: "17:00" },
  { id: "17:30:00", label: "17:30" },
  { id: "18:00:00", label: "18:00" },
  { id: "18:30:00", label: "18:30" },
  { id: "19:00:00", label: "19:00" },
  { id: "19:30:00", label: "19:30" },
  { id: "20:00:00", label: "20:00" },
  { id: "20:30:00", label: "20:30" },
  { id: "21:00:00", label: "21:00" },
  { id: "21:30:00", label: "21:30" },
  { id: "22:00:00", label: "22:00" },
  { id: "22:30:00", label: "22:30" },
  { id: "23:00:00", label: "23:00" },
  { id: "23:30:00", label: "23:30" },
  { id: "23:59:59", label: "23:59" },
];
